/**
 * Strip non-digits and auto-insert the dash for ZIP+4 (e.g. "941051234" → "94105-1234").
 * Use as a FormField `parse` prop.
 */
export function maskZipInput(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 9);
  if (digits.length > 5) {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }
  return digits;
}

const ZIP_RE = /^\d{5}(-\d{4})?$/;

/** Check whether a string is a valid 5-digit or 5+4 ZIP code. */
export function isValidZip(value: string): boolean {
  return ZIP_RE.test(value.trim());
}
